import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/media'

export const mediaService = {
    search,
    getList,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    getAll,
    getPagedList,
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

function getPagedList(offset, max) {
    return utilHelper.doRequest(`${relativeUrl}?max=${max}&offset=${offset}`, 'GET')
}

function getAll() {
    return utilHelper.doRequest(`${relativeUrl}/getAll`, 'GET')
}

function getList() {
    return utilHelper.doRequest(`${relativeUrl}`, 'GET')
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequestFile(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequestFile(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}